import React from "react";
import { useParams } from "react-router-dom";
import "../css/city-details.css";
import hotelsData from "../data/hotels-data";

const CityDetails = () => {
  const { category, city } = useParams();

  // Find category in hotelsData
  const selectedCategory = hotelsData.destinations.find(
    (dest) => dest.category.toLowerCase() === category.toLowerCase()
  );

  // Find city in selected category
  const selectedCity = selectedCategory?.cities.find(
    (c) => c.title.toLowerCase().replace(/\s+/g, "-") === city.toLowerCase()
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    fetch(form.action, {
      method: form.method,
      body: new FormData(form),
    })
      .then((response) => {
        if (response.ok) {
          window.location.href = "/thanks";
        } else {
          alert("There was an issue submitting the form. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Form submission error:", error);
        alert("An error occurred while submitting the form.");
      });
  };

  return (
    <div className="city-details-section">
      {selectedCity ? (
        <>
          <div className="city-details-container">
            <div className="city-details-container-left">
              <h1>Welcome to {selectedCity.title}</h1>
              <img src={selectedCity.image} alt={selectedCity.title} />
              {selectedCity.content.map((item, index) => (
                <p key={index}>{item.description}</p>
              ))}
            </div>
            <div className="city-details-container-right">
              <form
                action="https://api.web3forms.com/submit"
                method="POST"
                className="swipe-left"
                onSubmit={handleSubmit}
              >
                <h2>QUERY FORM</h2>
                <input
                  type="hidden"
                  name="subject"
                  value="Query MP Holidays Pvt Ltd."
                />
                <input
                  type="hidden"
                  name="from_name"
                  value="MP Holidays Pvt Ltd."
                />
                <input
                  type="hidden"
                  name="access_key"
                  value="43e459d4-2303-43a5-827a-74423261a455"
                ></input>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  required
                />
                <input
                  type="text"
                  name="mobilenumber"
                  placeholder="Enter your mobile number"
                  pattern="[0-9]{10}"
                  required
                />

                {/* Message Textarea */}
                <textarea name="message" placeholder="Enter your query here..." />

                {/* Submit Button */}
                <button type="submit" name="submit">
                  Send Query
                </button>
              </form>
              <br />
              {/* Contact Info Section */}
              <div className="contact-us-right swipe">
                <div className="contact-header-box">
                  <h2>Contact info</h2>
                  <p>
                    Have any Queries? Let us know. We will clear it for you at the
                    best.
                  </p>
                </div>
                {/* Office Info */}
                <div className="contact-box">
                  <div className="contact-box-left">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div className="contact-box-right">
                    <h3>Office</h3>
                    <p>
                      G10, near Nawada Metro Station, Shyam Park, Nawada Majra Village, Nawada, New Delhi, Delhi, 110059
                    </p>
                  </div>
                </div>
                {/* Email Info */}
                <div className="contact-box">
                  <div className="contact-box-left">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div className="contact-box-right">
                    <h3>Email</h3>
                    <a
                      href="mailto:welcome@mpholidays.online"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="mail us for hotel booking"
                    >
                      welcome@mpholidays.online
                    </a>
                  </div>
                </div>
                {/* Phone Info */}
                <div className="contact-box">
                  <div className="contact-box-left">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div className="contact-box-right">
                    <h3>Phone</h3>
                    <a
                      href="tel:+91 9319184060"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="call us for hotel booking"
                    >
                      +91 9319184060
                    </a>
                    <a
                      href="tel:+91 9318473156"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="call us for hotel booking"
                    >
                      +91 9318473156
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <h2>No city details found.</h2>
      )}
    </div>
  );
};

export default CityDetails;
